import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { OccupancyYearlyResponseSchema } from "../response/OccupancyYearlyResponse";

interface Filter {
    start: string;
    end: string;
    property_id: string;
    room_type_id?: string;
}

// [PERUBAHAN 1] Tambahkan 'group_by'
interface OccupancyParams {
    filter?: Filter;
    group_by?: 'year' | 'room_type';
    enabled?: boolean;
}

const API_VERSION = 'v4';

const useOccupancyYearly = (query: OccupancyParams) => {
    return useQuery({
        // [PERUBAHAN 2] Lengkapi queryKey
        queryKey: [
            'bookings', 'yearly', 'occupancy',
            query.filter?.property_id,
            query.filter?.start,
            query.filter?.end,
            query.filter?.room_type_id,
            query.group_by
        ],
        queryFn: async () => {
            // [PERUBAHAN 3] Susun params dengan benar
            const params = {
                filter: query.filter,
                group_by: query.group_by
            };
            const response = await privateApi.get(`/${API_VERSION}/occupancy-yearly`, { params });
            const validationResult = OccupancyYearlyResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Occupancy yearly data format");
            }
            return validationResult.data;
        },
        enabled: query.enabled !== false && !!query.filter?.property_id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useOccupancyYearly;